<template>
  <section id="about" class="about-section" aria-labelledby="about-title">
    <div class="about-section__content">
      <div class="about-section__intro">
        <h2 id="about-title">
          <span class="about-section__title-accent">{{ headline.lead }}</span>
          <span>{{ headline.rest }}</span>
        </h2>

        <div class="about-section__copy">
          <p v-for="(paragraph, index) in about.body" :key="`${index}-${paragraph}`">
            <span v-if="index === 1" v-html="formatGitHubLink(paragraph)"></span>
            <template v-else>{{ paragraph }}</template>
          </p>
        </div>

        <p class="about-section__signature"><span aria-hidden="true">Pi Teams</span> {{ about.signature }}</p>
      </div>

      <div class="about-section__gallery" :aria-label="about.galleryLabel">
        <div
          v-for="(column, columnIndex) in about.galleryColumns"
          :key="`column-${columnIndex}`"
          class="about-section__gallery-column"
          :class="`about-section__gallery-column--${columnIndex + 1}`"
        >
          <div class="about-section__gallery-track">
            <div
              v-for="loop in 2"
              :key="`loop-${loop}`"
              class="about-section__gallery-sequence"
              :aria-hidden="loop === 2 ? 'true' : undefined"
            >
              <div
                v-for="card in column"
                :key="`${loop}-${card.title}`"
                class="about-section__card"
                :class="[`about-section__card--${card.type}`, `about-section__card--${card.size || 'regular'}`]"
                :data-tone="card.tone"
                :id="card.tone === 'new' ? 'new-app' : undefined"
              >
                <template v-if="card.icon">
                  <img
                    :src="allIcons[card.icon]"
                    :alt="loop === 1 ? `${card.title} icon` : ''"
                  >
                  <span class="about-section__icon-label">{{ card.title }}</span>
                </template>
                <template v-else>
                  <span class="about-section__card-kicker">{{ card.kicker }}</span>
                  <strong>{{ card.title }}</strong>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import aboutData from '@/data/about.json';
import { all_icons as allIcons } from '@/assets/icons/includes';

export default {
  name: 'AboutSection',
  data() {
    return {
      about: aboutData,
      allIcons,
    };
  },
  computed: {
    headline() {
      const [lead, ...rest] = this.about.title.split(' ');
      return { lead, rest: rest.join(' ') };
    },
  },
  methods: {
    formatGitHubLink(paragraph) {
      return paragraph.replace('@0xeightnine', '<a href="https://github.com/0xeightnine" target="_blank" rel="noreferrer">0xeightnine</a>');
    },
  },
};
</script>
